const { id, log, searchWithin } = require("../std/index")


// Controller Library

const Controllers = {
  'cart': require('./cart'),
  'login': require('./shopify-login'),
  'slice': require('./slice'),
  'product': require('./product'),
  'lightbox': require('./lightbox'),
  'navigation': require('./navigation'),
  'auto-gallery': require('./auto-gallery')
};


// Functions

const invoke = (Controller, $region) => {
  return new Controller($region, searchWithin($region), invoke);
};

const initController = (ix, target, type = null) => {
  const $scope = $(target);
  const types = !type ? $scope.data('controller').split(' ') : [type];

  for (const type of types) {
    if (type !== "") {
      if (type && Controllers[type]) {
        invoke(Controllers[type], $scope);
      } else {
        console?.warn('Unknown controller:', type);
      }
    }
  }
};

module.exports = {
  invoke,
  initController
};
